import { render, staticRenderFns } from "./GenericDatePeriodSelector.vue?vue&type=template&id=3b5c54ea&scoped=true&"
import script from "./GenericDatePeriodSelector.vue?vue&type=script&lang=js&"
export * from "./GenericDatePeriodSelector.vue?vue&type=script&lang=js&"
import style0 from "./GenericDatePeriodSelector.vue?vue&type=style&index=0&id=3b5c54ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5c54ea",
  null
  
)

export default component.exports